
import React, { useEffect, useRef, useState } from 'react'
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from '../../API/axios';
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import ReportGmailerrorredSharpIcon from '@mui/icons-material/ReportGmailerrorredSharp';
import toast from 'react-hot-toast';
import { Button, Modal } from 'react-bootstrap';
import BlockSharpIcon from "@mui/icons-material/BlockSharp";
import CheckCircleOutlineSharpIcon from "@mui/icons-material/CheckCircleOutlineSharp";



const CompanyInteraction = ({ Compuid, isFollowed, isBlocked, getCompanyList }) => {
    const sessionId = localStorage.getItem("sessionId");
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    console.log("Compuid", Compuid);

    console.log("isFollowed", isFollowed, isBlocked);

    const handleToggleDropdown = (index) => {
        setShowDropdown((prev) => (prev === index ? null : index));
    };

    //************************ Follow User Start  ************************// 

    //************************ Follow Company Start  ************************//

    const FollowCompany = async () => {
        const data = {
            sessionId: sessionId,
            compUID: Compuid,
        };
        console.log("session ids", sessionId, Compuid);

        try {
            await axios.post("/CandidateAction/FollowCompany", data)
                .then((resData) => {
                    console.log("followedcompany", resData.data.message);

                    toast.success(resData.data.message)
                    getCompanyList()
                    console.log("following ");

                });
        } catch (e) {
            if (e.response && e.response.status === 404) {
                toast.error(e.response.data.message);
            } else {
                toast.error(e.response.data.message);
            }
        }
    };
    //************************ Follow Company End  ************************//

    //************************ Block Company Start  ************************//
    const [showModal, setShowModal] = useState(false);
    const handleShowModal = () => setShowModal(true);
    const handlecloseModal = () => setShowModal(false);

    const BlockCompany = async () => {
        const data = {
            sessionId: sessionId,
            compUID: Compuid,
        };
        console.log("Compuid", Compuid);
        
        try {
            await axios.post("/CandidateAction/BlockCompany", data)
                .then((resData) => {
                    console.log("Block Company", resData.data.message);
                    toast.success(resData.data.message);
                    getCompanyList()
                    handlecloseModal()
                });
        } catch (e) {
            if (e.response && e.response.status === 404) {
                toast.error(e.response.data.message);
                handlecloseModal()

            } else {
                toast.error(e.response.data.message);
            }
        }
    };

    const handleConfirmBlock = () => {
        BlockCompany();
        // setShowModal(false)

    };

    //************************ Block Company End  ************************//

    //************************ UnBlock Company Start  ************************//

    const UnBlockCompany = async () => {
        const data = {
            sessionId: sessionId,
            compUID: Compuid,
        };
        console.log("session ids", sessionId, Compuid);

        try {
            await axios.post("/CandidateAction/UnblockCompany", data)
                .then((resData) => {
                    console.log("Block Company", resData.data.message);
                    toast.success(resData.data.message);
                    getCompanyList()
                });
        } catch (e) {
            if (e.response && e.response.status === 404) {
                toast.error(e.response.data.message);
            } else {
                toast.error(e.response.data.message);
            }
        }
    };
    //************************ UnBlock Company End  ************************//

    //************************ UnFollow Company Start  ************************//
    const [showUnfollowModal, setshowUnfollowModal] = useState(false);
    const handleCloseModal = () => setshowUnfollowModal(false);
    const handleShow = () => setshowUnfollowModal(true);

    const UnFollow = async () => {
        const data = {
            sessionId: sessionId,
            compUID: Compuid,

        };
        try {
            await axios.post("/CandidateAction/UnfollowCompany", data).
                then((resData) => {
                    console.log("resData", resData.data.message);
                    toast.success(resData.data.message);
                    getCompanyList();
                    handleCloseModal();

                });
        } catch (e) {
            if (e.response && e.response.status === 404) {
                toast.error(e.response.data.message);
            } else {
                toast.error(e.response.data.message);
            }
        }
    };

    const handleConfirmUnfollow = () => {
        UnFollow();
    };
    //************************ UnFollow Company End  ************************//

    console.log('show', showModal);

    return (
        <>
            {/* <div className="button-readmore follow">
                        <button 
                            className="btn-employer "
                            onClick={() => {
                                FollowCompany();
                            }}
                        > Follow
                        </button>
                        </div> */}

            <Dropdown >
                <Dropdown.Toggle as="span" className="icon-togg">

                    <MoreHorizSharpIcon className="ms-2" />
                </Dropdown.Toggle>

                <Dropdown.Menu className='dropdown-cmpny' >
                    {isFollowed === true ? (
                        <Dropdown.Item
                            href="#"
                            className='follow-modal'
                            onClick={() => {
                                handleShow()
                            }}
                        >
                            <ReportGmailerrorredSharpIcon
                                style={{ cursor: "pointer", color: 'red' }}
                                className="material-symbols-sharp joblist-eye-icon me-2"
                            />
                            Unfollow Company
                        </Dropdown.Item>
                    ) : (
                        <Dropdown.Item
                            href="#"
                            className='follow-modal'
                            onClick={() => {
                                FollowCompany()
                            }}
                        >
                            <CheckCircleOutlineSharpIcon
                                style={{ cursor: "pointer" }}
                                className="material-symbols-sharp joblist-eye-icon me-2 mt-0"
                            />
                            Follow
                        </Dropdown.Item>

                    )}
                    {isBlocked === true ? (
                        <Dropdown.Item
                            href="#"
                            className='follow-modal'
                            onClick={() => {
                                UnBlockCompany()
                            }}
                        >
                            <ReportGmailerrorredSharpIcon
                                style={{ cursor: "pointer" }}
                                className="material-symbols-sharp joblist-eye-icon me-2"
                            />
                            Unblock Company
                        </Dropdown.Item>

                    ) : (
                        <Dropdown.Item
                            href="#"
                            className='follow-modal'
                            onClick={() => {
                                handleShowModal()
                            }}
                        >
                            <BlockSharpIcon
                                style={{ cursor: "pointer", color: 'red' }}
                                className="material-symbols-sharp joblist-eye-icon me-2 mt-0 block-icon"
                            />
                            Block
                        </Dropdown.Item>

                    )}

                </Dropdown.Menu>
            </Dropdown>


            {/* ...............block modal............  */}
            <Modal show={showModal} onHide={handlecloseModal} centered>
                <Modal.Header>
                    <Modal.Title>Confirm Block</Modal.Title>
                    <CloseSharpIcon className="pointer" onClick={handlecloseModal} />
                </Modal.Header>
                <Modal.Body className="settings">
                    <div className=" mb-3">
                        <p>Are you sure you want to block Company</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={handleConfirmBlock} className="btn btn-danger me-2">Confirm</button>
                    {/* <button onClick={handleClose} className="btn btn-secondary">Cancel</button> */}

                </Modal.Footer>

            </Modal>


            {/* ...............Unfollow modal............  */}

            <Modal show={showUnfollowModal} onHide={handleCloseModal} centered>
                <Modal.Header >
                    <Modal.Title> Unfollow</Modal.Title>
                    <CloseSharpIcon className="pointer" onClick={handleCloseModal} />
                </Modal.Header>
                <Modal.Body className="settings">
                    <div className=" mb-3">
                        <p>Are you sure you want to Unfollow Company</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={handleConfirmUnfollow} className="btn btn-danger me-2">Confirm</button>
                    {/* <button onClick={handleClose} className="btn btn-secondary">Cancel</button> */}

                </Modal.Footer>

            </Modal>
        </>
    )
}

export default CompanyInteraction